import UploadFilesSummaryMarsF from "./UploadFilesSummaryMarsF";
import useGetFormContext from "./useFormMarsComplete";
import FeedbackComponent from "../ResponsiveEvent.jsx/FeedbackComponent";
import KeyInformation from "../ResponsiveEvent.jsx/KeyInformation";

const SummaryAdmin = () => {
  const { eventFormData } = useGetFormContext();
  const content = (
    <>
      <div className="col-md-10 mb-3">
        {/* Key Information */}
        <div className="container bg-light rounded p-2 mt-2 mb-1">
          <KeyInformation eventId={eventFormData.eventId} />
        </div>

        {/* feedback */}
        <FeedbackComponent eventId={eventFormData.eventId} />

        {/* files upload and display  */}
        <UploadFilesSummaryMarsF></UploadFilesSummaryMarsF>

        <div style={{ height: "100px" }}></div>
      </div>
    </>
  );
  return content;
};

export default SummaryAdmin;